import { useState } from "react";

import { updatePartnerLike } from "@src/api/partner/partner";
import { PartnerType } from "@src/define/partner";
import toast from "@src/utils/toast";
import { waitFor, isExternalUrl, HOSTNAME } from "@src/utils";

export default function usePartnerLike() {
  const [isLoadingUpdateLike, setIsLoadingUpdateLike] = useState<boolean>(false);

  async function updatePartnerLikeFromServer(partnerUuid: string, currentIsLike: boolean) {
    if (isLoadingUpdateLike === true) return;

    setIsLoadingUpdateLike(true);

    try {
      const targetIsLikeState = !currentIsLike;
      await updatePartnerLike(partnerUuid, targetIsLikeState);
    } catch (error) {
      console.error("handleUpdatePortfolioLike", error);
      toast.error("오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      await waitFor(300);
      setIsLoadingUpdateLike(false);
    }
  }

  function showPartnerLikeToast(partnerType: number, currentIsLike: boolean) {
    let likePageUrl = `${HOSTNAME}/my-interest/like/partner?tab=${partnerType}`;
    if (partnerType === PartnerType.Planner) {
      likePageUrl = `${HOSTNAME}/my-interest/like/planner?tab=planner`;
    }

    if (currentIsLike === false) {
      toast.success("찜 목록에 추가했습니다.", {
        link: {
          text: "찜 목록 보기",
          url: isExternalUrl(likePageUrl),
        },
      });
    } else {
      toast.success("찜 목록에서 삭제했습니다.", { isShowClose: true });
    }
  }

  return {
    updatePartnerLikeFromServer,
    showPartnerLikeToast,
  };
}
